var map = {
	"./06112025_outing.png": 1812,
	"./25aug_panel_720.png": 979,
	"./AGU_LEAPH2025.png": 7087,
	"./AGU_LEAPH_website.png": 3600,
	"./APHA_2025.png": 8008,
	"./Ahmed_HEI.png": 1636,
	"./Alex_SOT2026.jpeg": 4372,
	"./Alex_SOT_article.png": 8438,
	"./Aline_AGUSciComm.png": 4932,
	"./Aline_DEVELOP.png": 2341,
	"./Aline_VOSAGU.png": 2469,
	"./GW_Research_Day.png": 2353,
	"./GW_Research_Day_2.png": 8986,
	"./Greta_ISEE2026.jpg": 4398,
	"./Greta_Sep252025.png": 530,
	"./Greta_publication.jpg": 3790,
	"./HAQAST2025.png": 2777,
	"./Josie CE.png": 9260,
	"./Josie_CE.png": 1023,
	"./Kelvin_Lungs.png": 971,
	"./Kelvin_SeedGrant.png": 5667,
	"./LEAPH_EndofSummer.png": 9580,
	"./LEAPH_ISEE.png": 8641,
	"./Lauren_Benchista.jpg": 1821,
	"./Lauren_SIOPE.PNG": 4111,
	"./Law_Logo.png": 6680,
	"./Maybank_MOS1.png": 1474,
	"./Maybank_Thesis.png": 2902,
	"./OneEarth.png": 5222,
	"./Research_Rodeo_2026.png": 2658,
	"./SoT2025.png": 1355,
	"./TravelAward_ISEE.png": 6982,
	"./TszKin_PM_article.jpg": 4400,
	"./isee2024.png": 7192,
	"./iseenac2023.png": 1595,
	"./newsRA.png": 8920,
	"./team.jpg": 2865,
	"./tks_defense.png": 4743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1572;